import React from "react";
import { Button as MaterialButton } from "@material-ui/core";

export function Button(props) {
    const { variant, label, handleClick } = props;

    return (
        <MaterialButton
            style={{
                margin: 5,
                minWidth: "50%",
                width: "328px",
                height: "44px",
            }}
            variant={variant}
            color="primary"
            onClick={handleClick}
        >
            {label}
        </MaterialButton>
    );
}
